import { useMutation } from '@tanstack/react-query';
import { api } from 'src/services';
import { CommentEntityType } from 'src/models';
import { useCommentListClient } from './useGetCommentList';

export type DeleteCommentResponse = {
  message: string;
  id: string;
};

export type UseDeleteCommentPayload = {
  commentId: string;
  entityType: CommentEntityType;
  entityId: string;
};

export const useDeleteComment = () => {
  const { deleteComment } = useCommentListClient();
  return useMutation({
    mutationKey: ['deleteComment'],
    mutationFn: ({ commentId }: UseDeleteCommentPayload) =>
      api
        .delete<DeleteCommentResponse>(`/v3/comments/${commentId}`)
        .then(({ data }) => data),
    onSuccess: (_, { commentId, entityType, entityId }) => {
      deleteComment({ entityType, entityId, commentId });
    },
  });
};
